<template>
	<div>
		<h1>Analysis of Data</h1>
		<InputSelectMulti
			question="How will data be analysed?"
			:options="options.dataAnalysis"
			v-model="$tera.project.ScopingWizard.dataAnalysis"
			questionMark="analysis-of-days-1"
		/>

		<!--Moved from Analysis Approach-->
		<InputSelectMulti
			question="How were the included data described/collated?"
			:options="approachOptions.dataDescription"
			v-model="$tera.project.ScopingWizard.dataDescription"
			questionMark="analysis-of-days-2"
		/>

		<InputSelectMulti
			question="How will your results be presented?"
			:options="approachOptions.resultsPresentation"
			v-model="$tera.project.ScopingWizard.resultsPresentation"
			questionMark="analysis-of-days-3"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>
<script>
import InputSelectMulti from "@/components/InputSelectMulti.vue";
import BasePreviewOutput from "@/components/BasePreviewOutput.vue";
import OutputAnalysisOfData from "./OutputAnalysisOfData.vue";
export default {
	name: "ViewScopingAnalysisOfData",
	components: {
		InputSelectMulti,
		BasePreviewOutput
	},
	data() {
		return {
			outputComponent: OutputAnalysisOfData,
			options: {
				dataAnalysis: [
					{ label: "narrative synthesis" },
					{ label: "content analysis" }
				]
			},
			approachOptions: {
				dataDescription: [
					{ label: "by themes" },
					{ label: "by country" },
					{ label: "by age group" }
				],
				resultsPresentation: [{ label: "graphical" }, { label: "tabular" }]
			}
		};
	}
};
</script>
<style scoped></style>
